import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
        encapsulation: ViewEncapsulation.None
})
export class NewsComponent implements OnInit {
  @ViewChild('relatedNewsModal') relatedNewsModal: TemplateRef<any>;

  public ads: any[] = [];
    // public pages  : any
  pages: any[] = [];
  selectedNewsIds: number[] = [];
  currentNewsId: number; // the news we're adding related news to

  constructor( 
    private apisService: ApisService,
    private router: Router,
            private toastr : ToastrService,
                public _translateService: TranslateService,
                    private modalService: NgbModal
  ) {} 

  // public currentPage = 1; 
  // public itemsPerPage = 10;
  // public totalItems = 0;
  public messages: any = {};
  public totalPages = 0;

  public tempData = [];
currentPage: number = 1;
itemsPerPage: number = 10;
totalItems: number = 0;
  @ViewChild(DatatableComponent) table: DatatableComponent;

  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;v

  ngOnInit(): void {
                 this.getTags(1);

  
     this.setDatatableMessages(); // set initial messages

    // listen for language change dynamically
    this._translateService.onLangChange.subscribe(() => {
      this.setDatatableMessages();
    });

  }

   private setDatatableMessages() {
    this.messages = {
      totalMessage: this._translateService.instant('MENU.DASHBOARD.total')
    };
  }
  

getTags(page: number = 1) {
  this.currentPage = page;

  this.apisService.news(page).subscribe({
    next: (response: any) => {
      console.log('API response:', response);

      this.pages = response.data || [];

      // Use total from API meta for pagination
      this.totalItems = response.meta?.total || this.pages.length;
      this.totalPages = response.meta?.last_page || Math.ceil(this.totalItems / this.itemsPerPage);

      console.log("pages:", this.pages, "totalItems:", this.totalItems);
    },
    error: (error: any) => {
      console.error('Error fetching news:', error);
    }
  });
}

onPageChange(page: number) {
  if (page === this.currentPage) return; // لو نفس الصفحة، متعملش حاجة
  this.getTags(page);
}


getTagss() {
    this.apisService.news().subscribe({
        next: (response: any) => {
            this.pages = response.data || [];
            this.totalItems = this.pages.length;
            console.log("pages:", this.pages);
        },
        error: (error: any) => {
            console.error('Error fetching contracts:', error);
            // يمكن إضافة معالجة للأخطاء هنا
        }
    });
}
openRelatedNewsModal(newsId: number) {
  this.currentNewsId = newsId;
  this.selectedNewsIds = []; // reset previous selection
  this.modalService.open(this.relatedNewsModal, { size: 'lg' });
}

saveRelatedNews(modal: any) {
  if (!this.selectedNewsIds || this.selectedNewsIds.length === 0) {
    this.toastr.error(
        this._translateService.instant('MENU.DASHBOARD.please_select_at_least_one_news')
      );
    return;
  }

  console.log('Sending related IDs:', this.selectedNewsIds);

  this.apisService.getRelatedNewsById(
    this.currentNewsId.toString(),
    this.selectedNewsIds
  ).subscribe({
    next: () => {
      this.toastr.success(
        this._translateService.instant('MENU.DASHBOARD.related_news_saved_successfully')
      );
      modal.close();
    },
    error: (err) => {
      console.error(err);
      this.toastr.error(
        this._translateService.instant('MENU.DASHBOARD.error_saving_related_news')
      );
    }
  });
}
onSelectNews(event: any, id: number) {
  if (event.target.checked) {
    // add ID to array
    if (!this.selectedNewsIds.includes(id)) {
      this.selectedNewsIds.push(id);
    }
  } else {
    // remove ID from array
    this.selectedNewsIds = this.selectedNewsIds.filter(x => x !== id);
  }
}


  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  

 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.ads = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }


     /*----------  deleting   ----------*/
 DeleteContracts(id:any){ 
  this.apisService.DeleteNews(id).subscribe({
    next: (response: any) => {
   this.toastr.success(
        this._translateService.instant('MENU.DASHBOARD.DELETED_SUCCESSFULLY')
      );       this.getTags();
    },
    error: (error: any) => {
      console.log(error);
   this.toastr.error(
        this._translateService.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
      );    }
  }
    
  )
 } 

 editProduct(productId: number) {
  this.router.navigate(['/edit-news', productId]);
}

confirmDelete(id: any) {
  Swal.fire({
    title: this._translateService.instant('MENU.DASHBOARD.CONFIRM_DELETE_TITLE'),
    text: this._translateService.instant('MENU.DASHBOARD.CONFIRM_DELETE_TEXT'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this._translateService.instant('MENU.DASHBOARD.YES_DELETE'),
    cancelButtonText: this._translateService.instant('MENU.DASHBOARD.CANCEL')
  }).then((result) => {
    if (result.isConfirmed) {
      this.DeleteContracts(id);
    }
  });
}


getContractRatio(row: any): number {
  const installment = row?.installments?.[0];

  if (!installment) {
    return 0;
  }

  const amount = Number(installment.amount || 0);
  const max = Number(installment.amount_max || 0);

  if (!max || max === 0) {
    return 0;
  }

  return +((amount / max) * 100).toFixed(1);
}

next() { 
  if (this.currentPage < this.totalPages) {
    this.getTags(this.currentPage + 1);
  }
}

prev() { 
  if (this.currentPage > 1) {
    this.getTags(this.currentPage - 1);
  }
}

goToPage(page: number) {
  if (page >= 1 && page <= this.totalPages) {
    this.getTags(page);
  }
}



}
